module.exports = __webpack_public_path__ + "img/bg01.52c7d361.gif";